module.exports = __webpack_public_path__ + "static/media/navbar-logo.8f85efb0.png";